import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { pushNotification } from '../../../components/PinnacleSnackbarProvider/PinnacleSnackbarProvider';
import { NotificationTypes } from '../../../components/PinnacleSnackbarProvider/PinnacleSnackbarProvider.types';
import { CONFIRM_LOGOUT_MSG, SUCCESSFULLY_LOGGED_OUT_MSG } from '../../../utils/constants';

interface LogoutDialogProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function LogoutDialog({ open, setOpen }: LogoutDialogProps) {
    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
    };

    const handleLogout = () => {
        setOpen(false);
        localStorage.removeItem('pinnacleStreamingV3AccessToken');
        sessionStorage.removeItem('pinnacleStreamingV3AccessToken');
        navigate('/login');
        pushNotification({
            details: SUCCESSFULLY_LOGGED_OUT_MSG,
            type: NotificationTypes.Success,
        });
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            slotProps={{
                paper: {
                    sx: {
                        backgroundColor: '#00080F',
                        color: '#fff',
                    }
                }
            }}
        >
            <DialogTitle id="responsive-dialog-title">
                {"Confirm Logout"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ color: '#fff' }}>
                    {CONFIRM_LOGOUT_MSG}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} sx={{ color: '#fff', textTransform: 'none' }}>
                    No
                </Button>
                <Button onClick={handleLogout} sx={{ color: '#fff', textTransform: 'none' }} autoFocus>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
}
